import * as api from "./api";

export async function submitSJRRequest(userId, body, options) {
	//api request for generating SJR request goes here
	try {
		const res = await api.post(`/reports/users/${userId}`, body, options);
		return res;
	} catch (err) {
		throw err;
	}
}
